import { $t } from "../../../utils/intl";
import { handleNumberField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextFieldValue } from "../text/text.config";
import { NumberFieldControl } from "./NumberFieldControl/NumberFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

export const numberFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "number",
  control: (props) => (
    <NumberFieldControl placeholder={$t(fieldsText.numberPlaceholder)} type="number" {...props} />
  ),
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
